import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import './logging/Logger'; // Import to run, no need to assign a variable.

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
